import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { getNumeral } from "../../utils/Number";
import { isNullOrNaN, isValueInChoiceList } from "../../utils";

const errorKey = "InvalidNumber";

export function validNumber(variable) {
    const { name: variableName } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const mentions = mentionsSelector(getState());
        if (mentions.length) {
            const mentionValue = mentions[0].value;
            const hasAnswerWithValue = isValueInChoiceList(mentionValue, variable);

            if (!hasAnswerWithValue) {
                const { interview } = getState();
                const language = interview.respondent.language || interview.language;

                const num = getNumeral(mentionValue, language).value();
                const isValid = !isNullOrNaN(num);
                if (!isValid) {
                    return { variableName, error: { key: errorKey } };
                }
            }
        }
        return null;
    };
}
